import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import { Routes as LakeToGoldRoutes } from './lake-to-gold'
import { Routes as TrailerCareRoutes } from './trailer-care'
import { StripePaymentIntentReset } from 'member-portal/components'
import { PATH, makePath } from 'config'

const propTypes = {}

function Routes() {
  const { path } = useRouteMatch()

  return (
    <StripePaymentIntentReset>
      <Switch>
        <Route path={makePath(path, PATH.MEMBERSHIP)}>
          <LakeToGoldRoutes />
        </Route>
        <Route path={makePath(path, PATH.TRAILER_CARE)}>
          <TrailerCareRoutes />
        </Route>
      </Switch>
    </StripePaymentIntentReset>
  )
}

Routes.propTypes = propTypes

export default Routes
